import Vue from 'vue'
import App from './App.vue'
import router from './router'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import 'font-awesome/css/font-awesome.min.css'
import './assets/styles/base.scss'
import './assets/styles/components.scss'

Vue.config.productionTip = false
Vue.use(ElementUI)

new Vue({
	router,
	render: h => h(App)
}).$mount('#app')